import React, { useCallback, useEffect, useState } from 'react';
import Loader from 'react-simple-loading';

import callApi from '../../utils/callApi';
import { CAM4_OAUTH_LOGIN } from '../../constants/apiUrls/apiUrls';
import { storeToken } from '../../utils/auth';
import LoginModalStore from '../../store/LoginModalStore';
import './Cam4OAuth.css';


function Cam4OAuthLogin(props) {
  const { user } = props;
  const [status, setStatus] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get('code');
  const state = urlParams.get('state');

  const redirectToHome = () => {
    window.location.href = '/home';
  };

  const handleOauthLogin = useCallback(() => {
    callApi(CAM4_OAUTH_LOGIN, 'POST', {}, { code, state }, {}, false, false, false).then((res) => {
      storeToken({
        token: res?.data?.token,
        username: res?.data?.username,
      });
      redirectToHome();
    }).catch((err) => {
      setStatus('Sorry! Only Gold CAM4 Members benefit from free access to Naked News.');
      setIsLoading(false);
    });
  }, [code, state]);

  const openLoginModal = () => {
    LoginModalStore.setShouldShowModal(true);
  };

  useEffect(() => {
    if (user?.authenticated) {
      setStatus('You are already signed in.');
      setIsLoading(false);
      redirectToHome();
    } else {
      handleOauthLogin();
    }
  }, []);

  const renderRetryButton = useCallback(() => {
    if (user?.authenticated) {
      return null;
    }

    return (
      <button
        className="btn btn-red"
        onClick={redirectToHome}
      >
        Back To Home
      </button>
    );
  }, [user?.authenticated]);

  if (isLoading || !status) {
    return (
      <div className="flex items-center justify-center cam4-oauth-page loader">
        <Loader color="white" />
      </div>
    );
  }

  if (!isLoading && status) {
    return (
      <div
        className="flex items-center justify-center cam4-oauth-page"
      >
        <div className="error-box flex items-center justify-center">
          <h2>{status}</h2>
          <h4>
            {renderRetryButton()}
          </h4>
        </div>
      </div>
    );
  }
}

export default Cam4OAuthLogin;
